export const logStamp = (...theArgs) => console.log(`[${(/* @__PURE__ */ new Date()).toLocaleString()}]`, ...theArgs);
export const errorStamp = (...theArgs) => console.error(`[${(/* @__PURE__ */ new Date()).toLocaleString()}]`, ...theArgs);
export function debugStamp(debug, ...theArgs) {
  if (debug) {
    logStamp(...theArgs);
  }
}
